import BaseParseObject from './BaseParseObject'

'use strict'

const StaticEquipment = BaseParseObject.extend('StaticEquipment', {
})


export default StaticEquipment
